<div>
  <div class="banner-list--top-section">
    <p-button
      type="button"
      class="ui-button-secondary"
      [ngStyle]="{ cursor: 'pointer' }"
      (click)="onCreateNewBanner()"
      label="{{ 'label.AddNew' | translate }}"
    ></p-button>
    <div class="banner-sizes">{{ bannerSizes }}</div>
  </div>

  <table class="table">
    <tr>
      <th></th>
      <th>{{ 'label.Name' | translate }}</th>
      <th>{{ 'label.Type' | translate }}</th>
      <th>{{ 'label.Image' | translate }}</th>
      <th>{{ 'label.Link' | translate }}</th>
      <th>{{ 'label.Views' | translate }}</th>
      <th>{{ 'label.Clicks' | translate }}</th>
      <th>{{ 'label.ClickThroughRate' | translate }}</th>
      <th>{{ 'label.Date' | translate }}</th>
      <th>{{ 'label.Active' | translate }}</th>
    </tr>

    <tr *ngFor="let item of bannerList">
      <td>
        <p-button
          type="button"
          class="ui-button-secondary"
          [ngStyle]="{ cursor: 'pointer' }"
          label="{{ 'label.Edit' | translate }}"
          [routerLink]="[
            '/settings/banner-positions',
            item.positionId,
            'banners',
            item.bannerId
          ]"
        ></p-button>
      </td>
      <td>{{ item.name }}</td>
      <td>{{ type[item.typeId] }}</td>
      <td>
        <div *ngIf="item.imageFileName != null; else elseBlockFileName">
          <a href="{{ item.imageFileUrl }}" target="_blank">{{
            'label.Image' | translate
          }}</a>
        </div>
        <ng-template #elseBlockFileName>
          <div>---</div>
        </ng-template>
      </td>
      <td>
        <div *ngIf="item.link != null; else elseBlockLink">
          <a href="{{ item.link }}" target="_blank">{{
            'label.Link' | translate
          }}</a>
        </div>
        <ng-template #elseBlockLink>
          <div>---</div>
        </ng-template>
      </td>
      <td>{{ item.viewCount }}</td>
      <td>{{ item.clickCount }}</td>
      <td>{{ item.clickRate }}%</td>
      <td>{{ item?.deactivationDate | date : dateFormat }}</td>
      <td>
        <label
          *ngIf="item.statusId != status.Draft; else elseBlock"
          class="switch"
        >
          <input
            type="checkbox"
            [checked]="item.statusId == status.Active"
            (change)="
              onBannerStatusChange(item.bannerId, $event.target.checked)
            "
          />
          <span class="slider round"></span>
        </label>
        <ng-template #elseBlock>
          <div style="color: red">{{ 'label.draft' | translate }}</div>
        </ng-template>
      </td>
    </tr>
  </table>
</div>
